// extracted by mini-css-extract-plugin
export var featureBox = "feature-box-module--featureBox--xmKf7";
export var featureBox_inner = "feature-box-module--featureBox_inner--E5+Zj";